/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quotes_TitleInputs */

const da_forside_quotes_title = /** @type {(inputs: Forside_Quotes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad lærere siger`)
};

/** @type {(inputs: Forside_Quotes_TitleInputs) => LocalizedString} */
const en_forside_quotes_title = da_forside_quotes_title;

/**

* @param {Forside_Quotes_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quotes_title = /** @type {((inputs?: Forside_Quotes_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quotes_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quotes_title(inputs)
	return /** @type {LocalizedString} */ ("Hvad lærere siger")
});